import React from "react";

const DiscountArea = ({ smallImg, largeImg }) => {
  return (
    <>
      <section id="about_offer_banner" className="section_padding_bottom">
        <div className="container">
          <div className="row">
            <h2 className="d-none">Heading</h2>
            <div className="col-lg-4">
              <div className="about_offer_banner">
                <img src={smallImg} alt="Small Banner" />
              </div>
            </div>
            <div className="col-lg-8">
              <div className="about_offer_banner">
                <img src={largeImg} alt="Large Banner" />
                <div className="about_offer_text"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DiscountArea;
